import { render, staticRenderFns } from "./TitleBar.template.vue?vue&type=template&id=cb4a500a&scoped=true&"
var script = {}
import style0 from "./TitleBar.template.vue?vue&type=style&index=0&id=cb4a500a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a500a",
  null
  
)

export default component.exports